module.exports = __webpack_public_path__ + "static/img/04@2x.4ccf9b98.png";